export default __webpack_public_path__ + "static/media/AGC_2022_R4_QP_Class_2.0c2ec6ec.pdf";